import { api } from '@/lib/api/client';
import type {
  BrandInventoryItem,
  BrandInventoryState,
} from '@/lib/api/types';

export interface BrandInventoryFilters {
  brandId?: number;
  state?: BrandInventoryState;
  /** Comma-separated. Backend matches any (OR semantics). */
  tag?: string;
  page?: number;
  limit?: number;
}

export interface CreateBrandInventoryPayload {
  brandId: number;
  name: string;
  image?: string;
  quantity: number;
  estimated?: boolean;
  rating?: number;
  tags?: string[];
}

export interface UpdateBrandInventoryPayload {
  name?: string;
  image?: string;
  quantity?: number;
  estimated?: boolean;
  state?: BrandInventoryState;
  writeOffReason?: string;
  rating?: number;
  tags?: string[];
}

export const brandInventoryApi = {
  list: (filters: BrandInventoryFilters) =>
    api.list<BrandInventoryItem>('/co-brand-inventory', {
      page: filters.page,
      perPage: filters.limit,
    }, {
      // brandId/state/tag forwarded as plain query params (controller
      // reads them via ListCoBrandInventoryDto). buildListParams keeps
      // only its known keys; pass-through goes via config.params.
      params: {
        brandId: filters.brandId,
        state: filters.state,
        tag: filters.tag,
      },
    }),

  detail: (id: number) =>
    api.get<BrandInventoryItem>(`/co-brand-inventory/${id}`),

  create: (payload: CreateBrandInventoryPayload) =>
    api.post<BrandInventoryItem>('/co-brand-inventory', payload),

  update: (id: number, payload: UpdateBrandInventoryPayload) =>
    api.patch<BrandInventoryItem>(`/co-brand-inventory/${id}`, payload),

  remove: (id: number) => api.delete<{ ok: true }>(`/co-brand-inventory/${id}`),
};
